import LayoutSetLevelZero from 'components/ui/layout-set/general/layout-set-level-zero';

import PageIndexList from 'components/pages/professional/stuff-to-eat/food-products/list/page-index-list';
import ButtonAddNewStuffToEat from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-button-add-new';

import PageStuffToEatMainDetailsAdd from 'components/pages/professional/stuff-to-eat/shared/details/main-details/page-stuff-to-eat-main-details-add';

import LayoutSetStuffToEatFoodProduct from 'components/ui/layout-set/stuff-to-eat/layout-set-stuff-to-eat-food-product';
import PageStuffToEatDetailsView from 'components/pages/professional/stuff-to-eat/shared/details/page-stuff-to-eat-details-view';
import PageStuffToEatMainDetailsView from 'components/pages/professional/stuff-to-eat/shared/details/main-details/page-stuff-to-eat-main-details-view';

import PageStuffToEatCategories from 'components/pages/professional/stuff-to-eat/shared/details/categories/page-stuff-to-eat-categories';

import PageStuffToEatNutritionInformation from 'components/pages/professional/stuff-to-eat/shared/details/nutrition-information/page-stuff-to-eat-nutrition-information';

import PageStuffToEatServingSizes from 'components/pages/professional/stuff-to-eat/shared/details/serving-sizes/page-stuff-to-eat-serving-sizes';
import PageStuffToEatCredServingSize from 'components/pages/professional/stuff-to-eat/shared/details/serving-sizes/page-stuff-to-eat-cred-serving-size';

import PageSearchOverflow from 'components/pages/professional/stuff-to-eat/shared/search-east/page-search-overflow';
import PageSearchStuffToEat from 'components/pages/professional/stuff-to-eat/shared/search-east/page-search-stuff-to-eat';

import PageStuffToEatImages from 'components/pages/professional/stuff-to-eat/shared/details/images/page-stuff-to-eat-images';
import PageStuffToEatImagesUpload from 'components/pages/professional/stuff-to-eat/shared/details/images/page-stuff-to-eat-images-upload';
import PageStuffToEatImagesManage from 'components/pages/professional/stuff-to-eat/shared/details/images/page-stuff-to-eat-images-manage';

import PageStuffToEatExchanges from 'components/pages/professional/stuff-to-eat/shared/details/exchanges/page-stuff-to-eat-exchanges';
import PageStuffToEatAddExchange from 'components/pages/professional/stuff-to-eat/shared/details/exchanges/page-stuff-to-eat-add-exchange';
import PageStuffToEatEditExchange from 'components/pages/professional/stuff-to-eat/shared/details/exchanges/page-stuff-to-eat-edit-exchange';

import PageStuffToEatChangeStatus from 'components/pages/professional/stuff-to-eat/shared/details/settings/page-stuff-to-eat-change-status';
import PageStuffToEatChangeDelete from 'components/pages/professional/stuff-to-eat/shared/details/delete/page-stuff-to-eat-delete';

import PageStuffToEatAllergens from 'components/pages/professional/stuff-to-eat/shared/details/allergens/page-stuff-to-eat-allergens';

import { STUFF_TO_EAT_KEYS } from 'constants/types';

const type = STUFF_TO_EAT_KEYS.food_product;

export default [
  {
    path: '/professional/stuff-to-eat/food-products',
    props: {
      index: true,
    },
    meta: { auth: true },
    component: LayoutSetLevelZero,
    children: [
      {
        path: '',
        name: 'food-products-list',
        components: {
          default: PageIndexList,
          collapsedMenuTop: ButtonAddNewStuffToEat,
        },
        props: {
          default: route => ({
            page: Number(route.query.page),
            meta: {
              title: 'label.food_products',
              section: 'label.stuff_to_eat',
              navigation: {
                index: 'food-products-list',
                status: 'food-product-status-change',
                edit: 'food-product-main-details-view',
              },
            },
          }),
          collapsedMenuTop: {
            type,
            link: 'food-product-main-details-add',
            title: 'label.add_new_food_product',
          },
        },
        meta: {
          auth: true,
        },
        children: [
          {
            path: 'add',
            name: 'food-product-main-details-add',
            component: PageStuffToEatMainDetailsAdd,
            props: {
              type,
              meta: {
                title: 'label.add_new_food_product',
                navigation: {
                  cancel: 'food-products-list',
                  success: 'food-product-main-details-view',
                },
              },
            },
            meta: { auth: true },
          },
        ],
      },
    ],
  }, // end ~ path: '/professional/stuff-to-eat/food-products
  {
    path: '/professional/stuff-to-eat/food-products/:id(\\d+)',
    component: LayoutSetStuffToEatFoodProduct,
    meta: { auth: true },
    props: route => ({
      id: route.params.id,
      meta: {
        navigation: {
          index: 'food-products-list',
          status: 'food-product-status-change',
        },
      },
    }),
    children: [
      {
        path: 'details',
        component: PageStuffToEatDetailsView,
        props: route => ({
          id: route.params.id,
        }),
        meta: { auth: true },
        children: [
          {
            path: 'main',
            name: 'food-product-main-details-view',
            component: PageStuffToEatMainDetailsView,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.details',
                title: 'label.main_information',
                navigation: {
                  back: 'food-products-list',
                },
              },
            }),
            meta: { auth: true },
          },
          {
            path: 'categorisation',
            name: 'food-product-categorisation',
            component: PageStuffToEatCategories,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.general_information',
                title: 'label.categorisation',
                navigation: {
                  back: 'food-products-list',
                },
              },
            }),
            meta: { auth: true },
          },
          {
            path: 'nutrition-information',
            name: 'food-product-nutrition-information',
            component: PageStuffToEatNutritionInformation,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.general_information',
                title: 'label.nutrition_information',
              },
            }),
            meta: { auth: true },
          },
          {
            path: 'allergens',
            name: 'food-product-allergens',
            component: PageStuffToEatAllergens,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.general_information',
                title: 'label.allergens',
              },
            }),
            meta: { auth: true },
          },
        ],
      },
      {
        path: 'related-content',
        component: PageStuffToEatDetailsView,
        props: route => ({
          id: route.params.id,
        }),
        meta: { auth: true },
        children: [
          {
            path: 'serving-sizes',
            name: 'food-product-serving-sizes',
            component: PageStuffToEatServingSizes,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.related_content',
                title: 'label.serving_sizes',
                navigation: {
                  edit: 'food-product-serving-sizes-edit',
                },
              },
            }),
            children: [
              {
                path: 'add',
                name: 'food-product-serving-sizes-add',
                component: PageStuffToEatCredServingSize,
                props: route => ({
                  type,
                  id: route.params.id,
                  meta: {
                    title: 'label.add_new_serving_size',
                    stuff_to_eat: 'label.drink',
                    navigation: {
                      cancel: 'food-product-serving-sizes',
                    },
                  },
                }),
              },
              {
                path: 'edit/:servingSizeID',
                name: 'food-product-serving-sizes-edit',
                component: PageStuffToEatCredServingSize,
                props: route => ({
                  type,
                  id: route.params.id,
                  servingSizeID: route.params.servingSizeID,
                  cancelNavigation: 'food-product-serving-sizes',
                  meta: {
                    title: 'label.edit_serving_size',
                    stuff_to_eat: 'label.drink',
                    navigation: {
                      cancel: 'food-product-serving-sizes',
                    },
                  },
                }),
              },
            ],
          },
          {
            path: 'images',
            name: 'food-product-images',
            component: PageStuffToEatImages,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                navigation: {
                  manage: 'food-product-images-manage',
                },
              },
            }),
            children: [
              {
                path: 'upload',
                name: 'food-product-images-upload',
                component: PageStuffToEatImagesUpload,
                props: route => ({
                  id: route.params.id,
                  productType: type,
                  meta: {
                    title: 'label.upload_images',
                    stuff_to_eat: 'label.drink',
                    navigation: {
                      cancel: 'food-product-images',
                    },
                  },
                }),
              },
              {
                path: 'manage',
                name: 'food-product-images-manage',
                component: PageStuffToEatImagesManage,
                props: route => ({
                  id: route.params.id,
                  productType: type,
                  meta: {
                    title: 'label.manage_images',
                    stuff_to_eat: 'label.drink',
                    navigation: {
                      cancel: 'food-product-images',
                    },
                  },
                }),
              },
            ],
          }, // end ~ path: 'images'...
          {
            path: 'exchanges',
            name: 'food-product-exchanges',
            component: PageStuffToEatExchanges,
            props: route => ({
              id: route.params.id,
              entityType: type,
              meta: {
                section: 'label.related_content',
                title: 'label.exchanges',
                navigation: {
                  edit: 'food-product-exchanges-edit',
                },
              },
            }),
            children: [
              {
                path: 'search/:entityType',
                component: PageSearchOverflow,
                props: {
                  cancelNavigation: 'food-product-exchanges',
                  meta: {
                    navigation: {
                      cancel: 'food-product-exchanges',
                    },
                  },
                },
                children: [
                  {
                    path: '',
                    component: PageSearchStuffToEat,
                    name: 'search-food-product-exchanges',
                    props: route => ({
                      id: route.params.id,
                      layoutEastBlock: true,
                      entityContentID: route.params.entityType,
                      entityType: route.params.entityType,
                      meta: {
                        navigation: {
                          itemParamName: 'exchangeID',
                          itemClickNavigation: 'food-product-exchanges-add',
                        },
                      },
                    }),
                    meta: {
                      title: 'label.search_food_products',
                    },
                    children: [
                      {
                        path: 'add/:exchangeID',
                        name: 'food-product-exchanges-add',
                        component: PageStuffToEatAddExchange,
                        props: route => ({
                          id: route.params.id,
                          productType: type,
                          exchangeID: route.params.exchangeID,
                          meta: {
                            title: 'label.add_new_exchange',
                            stuff_to_eat: 'label.food_product',
                            navigation: {
                              back: 'search-food-product-exchanges',
                              cancel: 'food-product-exchanges',
                            },
                          },
                        }),
                      },
                    ],
                  },
                ],
              },
              {
                path: 'edit/:exchangeID',
                name: 'food-product-exchanges-edit',
                component: PageStuffToEatEditExchange,
                props: route => ({
                  id: route.params.id,
                  exchangeID: route.params.exchangeID,
                  entityExchangeID: route.query.entityExchangeID,
                  productType: type,
                  meta: {
                    title: 'label.edit_exchange',
                    stuff_to_eat: 'label.drink',
                    navigation: {
                      cancel: 'food-product-exchanges',
                    },
                  },
                }),
              },
              {
                path: 'help',
                name: 'food-product-exchanges-help',
                component: PageStuffToEatEditExchange,
                props: {
                  meta: {
                    title: 'label.help',
                    meta: {
                      navigation: {
                        cancel: 'food-product-exchanges',
                      },
                    },
                  },
                },
              },
            ],
          }, // end ~ path: 'exchanges'...
        ],
      },
      {
        path: 'settings',
        component: PageStuffToEatDetailsView,
        props: route => ({
          id: route.params.id,
        }),
        meta: { auth: true },
        children: [
          {
            path: 'status',
            name: 'food-product-status-change',
            component: PageStuffToEatChangeStatus,
            props: route => ({
              type,
              id: route.params.id,
              meta: {
                section: 'label.settings',
                title: 'label.status',
                navigation: {
                  index: 'food-products-list',
                },
              },
            }),
          },
          {
            path: 'delete',
            name: 'food-product-delete',
            component: PageStuffToEatChangeDelete,
            props: route => ({
              id: route.params.id,
              type,
              meta: {
                title: 'label.delete_food_product',
                section: 'label.settings',
                navigation: {
                  index: 'food-products-list',
                  success: 'food-products-list',
                },
              },
            }),
          },
        ],
      },
    ],
  }, // end ~ path: '/professional/stuff-to-eat/food-products/:id(\\d+)'...
];



// WEBPACK FOOTER //
// ./src/router/professional/stuff-to-eat/router-food-products.js